import { render, staticRenderFns } from "./AppAddDeclarationSummaryCompany.vue?vue&type=template&id=fd7d9c48&scoped=true&"
import script from "./AppAddDeclarationSummaryCompany.vue?vue&type=script&lang=ts&"
export * from "./AppAddDeclarationSummaryCompany.vue?vue&type=script&lang=ts&"
import style0 from "./AppAddDeclarationSummaryCompany.vue?vue&type=style&index=0&id=fd7d9c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7d9c48",
  null
  
)

export default component.exports